export enum HrResourceName {
    common = 'common',
    hrCommon = 'hr-common',
    hrComCodeText = 'hr-com-code-text',
    hrGenCodeTextModuleRelation = 'hr-gen-code-text-module-relation',
    hrGenCodeTextRelation = 'hr-gen-code-text-relation',
    hrConstraintException = 'hr-constraint-exception',
    hrPerAddress = 'hr-per-address',
    hrPerAward = 'hr-per-award',
    hrPerBank = 'hr-per-bank',
    hrPerBorrowing = 'hr-per-borrowing',
    hrPerBoxes = 'hr-per-boxes',
    hrOrgCards = 'hr-org-cards',
    hrPerCertificate = 'hr-per-certificate',
    hrPerContract = 'hr-per-contract',
    hrPerCourt = 'hr-per-court',
    hrPerDegree = 'hr-per-degree',
    hrPerEduInstFaculty = 'hr-per-edu-inst-faculty',
    hrPerEducation = 'hr-per-education',
    hrPerExam = 'hr-per-exam',
    hrPerSubExam = 'hr-per-subexam',
    hrPerExternalService = 'hr-per-external-service',
    hrPerForeignLanguage = 'hr-per-foreign-language',
    hrPerHealth = 'hr-per-health',
    hrPerDeclarationGoods = 'hr-per-declaration-goods',
    hrPerHierarchyGroupDetail = 'hr-per-hierarchy-group-detail',
    hrPerHistoricalData = 'hr-per-historical-data',
    hrPerIdentification = 'hr-per-identification',
    hrPerIdentity = 'hr-per-identity',
    hrPerInstFacultyBranch = 'hr-per-inst-faculty-branch',
    hrPerMilitary = 'hr-per-military',
    hrPerObjectConnection = 'hr-per-object-connection',
    hrPerObjectContent = 'hr-per-object-content',
    hrPerObjectDefinition = 'hr-per-object-definition',
    hrPerObjectDetail = 'hr-per-object-detail',
    hrPerObjectRelationship = 'hr-per-object-relationship',
    hrPerCriteriaCatalogDefinition = 'hr-per-criteria-catalog-definition',
    hrPerOrganizationManagement = 'hr-per-organization-management',
    hrPerPersonnel = 'hr-per-personnel',
    hrPerPersonnelOrganization = 'hr-per-personnel-organization',
    hrPerPhysicalStandard = 'hr-per-physical-standard',
    hrPerExperience = 'hr-per-experience',
    hrPerSpecialSituation = 'hr-per-special-situation',
    hrPerSubtypeSchool = 'hr-per-subtype-school',
    hrPerSyndicate = 'hr-per-syndicate',
    hrPerTelephone = 'hr-per-telephone',
    hrPerTypeEduSubtype = 'hr-per-type-edu-subtype',
    hrPerVehicle = 'hr-per-vehicle',
    hrPerWeapon = 'hr-per-weapon',
    hrPerFamily = 'hr-per-family',
    hrPerPunishment = 'hr-per-punishment',
    hrPerMovementInfo = 'hr-per-movement-info',
    hrPerMovementReturnStatus = 'hr-per-movement-return-status',
    hrPerMovementServiceStatus = 'hr-per-movement-service-status',
    hrPerMovementStMandatoryFields = 'hr-per-movement-st-mandatory-fields',
    hrPerLeaveRequest = 'hr-per-leave-request',
    hrPerCadreDefinition = 'hr-per-cadre-definition',
    hrOrgCadrePeriod = 'hr-org-cadre-period',
    hrGenCertificate = 'hr-gen-certificate',
    hrGenEmployeeSubtype = 'hr-gen-employee-subtype',
    hrGenHrmDetail = 'hr-gen-hrm-detail',
    hrGenHrmDetailType = 'hr-gen-hrm-detail-type',
    hrGenHrmType = 'hr-gen-hrm-type',
    hrGenWorkSubarea = 'hr-gen-work-subarea',
    hrGenTimeConstraint = 'hr-gen-time-constraint',
    hrPayEngineScript = 'hr-pay-engine-script',
    hrPayEngineResult = 'hr-pay-engine-result',
    hrPayCommonPay = 'hr-pay-common-pay',
    hrPayDeductionPay = 'hr-pay-deduction-pay',
    hrPayIndividualPay = 'hr-pay-individual-pay',
    hrPayIncomeTax = 'hr-pay-income-tax',
    hrPayMinLivAllowanceAmount = 'hr-pay-min-liv-allowance-amount',
    hrPaySstPercentage = 'hr-pay-sst-percentage',
    hrPaySstInfo = 'hr-pay-sst-info',
    hrPayTaxManagementTr = 'hr-pay-tax-management-tr',
    hrPayGroupWorkInfoTr = 'hr-pay-group-work-info-tr',
    wageManagementCard = 'wage-management-card',
    hrPayGroupWorkSubare = 'hr-pay-group-work-subarea',
    hrPayAdditionalPay = 'hr-pay-additional-pay',
    hrPayPayrollSwitch = 'hr-pay-payroll-switch',
    hrPayrollSwitchRelation = 'hr-payroll-switch-relation',
    hrPayrollSwitchOffsetDate = 'hr-payroll-switch-offset-date',
    hrExpenseTypeWageTypeRelation = 'hr-expense-type-wage-type-relation',
    hrTravelWageTypeRelation = 'hr-travel-wage-type-relation',
    hrPayPayrollSwitchState = 'hr-pay-payroll-switch-state',
    hrPayPayrollTypeManner = 'hr-pay-payroll-type-manner',
    hrPayPayrollKindManner = 'hr-pay-payroll-kind-manner',
    hrPaySiDeductionLawRate = 'hr-pay-si-deduction-law-rate',
    hrPayTravelExpenseDeductionAmount = 'hr-pay-travel-expense-deduction-amount',
    hrPayWageManagementCard = 'hr-pay-wage-management-card',
    hrPayWageType = 'hr-pay-wage-type',
    hrPayEmployeeSubtype = 'hr-pay-group-employee-subtype',
    hrPayStampTaxRate = 'hr-pay-stamp-tax-rate',
    hrPayPeriodDate = 'hr-pay-period-date',
    hrPayRun = 'hr-pay-run',
    hrOrgSubunit = 'hr-org-subunit',
    hrOrgEmployee = 'hr-org-employee',
    hrPayName = 'hr-pay-name',
    hrPayConstantAmount = 'hr-pay-constant-amount',
    hrPayWtMannerValue = 'hr-pay-wt-manner-value',
    hrPayConstantNumber = 'hr-pay-constant-number',
    hrPayConstantPublic = 'hr-pay-constant-public',
    hrPayWtCumulative = 'hr-pay-wt-cumulative',
    hrPayAdditionalPayRate = 'hr-pay-additional-pay-rate',
    hrPayPosDutyReprCompIndicator = 'hr-pay-pos-duty-repr-comp-indicator',
    hrPayDevelopmentAllowanceRate = 'hr-pay-development-allowance-rate',
    hrPayForeignLangCompIndicator = 'hr-pay-foreign-lang-comp-indicator',
    hrPayFringePayPoint = 'hr-pay-fringe-pay-point',
    hrPayAdminDutyAllowanceRate = 'hr-pay-admin-duty-allowance-rate',
    hrPayHigherEduCompensationRate = 'hr-pay-higher-edu-compensation-rate',
    hrPayRetirmentDeductionRate = 'hr-pay-retirement-deduction-rate',
    hrPaySpecialServiceCompRate = 'hr-pay-special-service-comp-rate',
    hrPayUniversityAllowanceRate = 'hr-pay-university-allowance-rate',
    hrPerIdentificationSubtype = 'hr-per-identification-subtype',
    hrPerOrganizationGeneralInfo = 'hr-per-organization-general-info',
    hrOrganizationResponsibility = 'hr-org-responsibility',
    hrPerOrganizationTemplate = 'hr-per-organization-template',
    hrPerDisability = 'hr-per-disability',
    hrPerSuspension = 'hr-per-suspension',
    hrPerMovement = 'hr-per-movement',
    hrGenCalendar = 'hr-gen-calendar',
    hrGenBreak = 'hr-gen-break',
    hrGenShift = 'hr-gen-shift',
    hrGenCalUnworked = 'hr-gen-cal-unworked',
    hrGenCalWorked = 'hr-gen-cal-worked',
    hrPerAttachment = 'hr-per-attachment',
    hrPerEvaluationRuleDefinition = 'hr-per-evaluation-rule-definition',
    hrPerEvaluationPathDefinition = 'hr-per-evaluation-path-definition',
    hrPerEvaluationAreaDefinition = 'hr-per-evaluation-area-definition',
    hrPerComission = 'hr-per-comission',
    hrPerComissionMembers = 'hr-per-comission-members',
    hrPerComissionCards = 'hr-per-comission-cards',
    hrOrgStaticInfo = 'hr-org-static-info',
    hrOrgDefMov = 'hr-org-def-mov',
    hrPerDegreeEducationLevel = 'hr-per-degree-education-level',
    hrPerMonthlyIndicator = 'hr-per-monthly-indicator',
    hrPerAdditionalIndicator = 'hr-per-additional-indicator',
    hrPerHtpServiceStatus = 'hr-per-htp-service-status',
    hrPerHtpServiceReason = 'hr-per-htp-service-reason',
    hrPerHtpFormOfReturn = 'hr-per-htp-form-of-return',
    hrPerHtpServiceStatusDataMatch = 'hr-per-htp-service-status-data-match',
    hrPerHtpServiceReasonDataMatch = 'hr-per-htp-service-reason-data-match',
    hrPerHtpFormOfReturnDataMatch = 'hr-per-htp-form-of-return-data-match',
    hrPerHtpExamCodeDataMatch = 'hr-per-htp-exam-code-data-match',
    hrPerUniFacultyIntegrationDataMatch = 'hr-per-uni-faculty-integration-data-match',
    hrEnumTrueFalse = 'enum-true-false',
    rndIncomeTaxDeducPerc = 'rnd-income-tax-deduc-perc',
    rndProject = 'rnd-project',
    hrPerHitapHataKodu = 'hitap-hata-kodu',
    hrPerHealthQuestion = 'hr-per-health-question',
    hrPrfUnitType = 'hr-prf-unit-type',
    hrFlatAllocation = 'hr-flat-allocation',
}
